export default __webpack_public_path__ + "static/NotoSans-Thin-f8eb04149ef4682fef3dcae9a412f79f.ttf";